import axios, { AxiosResponse } from "axios"

function fetchTransaction(id: string) {
	return axios.get<any, AxiosResponse<{ name: string }>>(
		`/getTransaction/${id}`
	)
}

export default fetchTransaction
